// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1gN5T","header":"styles_header__1YmMM","activity":"styles_activity__2Tel_","content":"styles_content__2CiWQ"};